import { render, staticRenderFns } from "./RestGiftCard.vue?vue&type=template&id=3c80d51c&"
import script from "./RestGiftCard.vue?vue&type=script&lang=js&"
export * from "./RestGiftCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports